import Header from './Header';

export { STICKY_HEADER_STYLE, HEADER_WRAPPER_ID } from './Header';
export default Header;
